<template>
  <Box :aspect="0.4" class="map-container">
    <GMapMap
      :center="mapCenter"
      :zoom="value ? 14 : 10"
      :options="defaultOptions"
      class="h-fit"
      map-type-id="roadmap"
      @click="setGisLocation"
    >
      <GMapCircle
        v-if="value"
        :radius="radius ?? 100"
        :center="(typeof value?.lat === 'number' && typeof value?.long === 'number') ? {
          lat: value?.lat,
          lng: value?.long,
        } : undefined"
        :options="{
          clickable: false,
          strokeWeight: 0,
          fillColor: '#7B61FF',
          fillOpacity: 0.3,
          editable: true,
        }"
        :radius_changed="true"
        :center_changed="true"
        @radius_changed="setRadius"
        @center_changed="setCenter"
      />
    </GMapMap>
  </Box>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import Box from '@components/utils/Box.vue';
import type { Location } from '@/entities/Entities';
import { syncRef } from '@/hooks/state';
import { defaultCenter, defaultOptions } from '@/utils/map';

interface Props {
  modelValue?: Location;
  radius?: number;
}

const emit = defineEmits(['update:modelValue', 'update:radius']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });
const radius = useVModel(props, 'radius', emit, { passive: true });

const mapCenter = syncRef(value, (location) =>
  (location && typeof location?.lat === 'number' && typeof location?.long === 'number'
    ? {
      lat: location.lat,
      lng: location.long,
    }
    : defaultCenter));

const setGisLocation = (event: google.maps.MapMouseEvent) => {
  if (event.latLng) {
    value.value = {
      lat: event.latLng?.lat(),
      long: event.latLng?.lng(),
    };
  }
};

const setRadius = (rad: number) => {
  if (radius.value !== rad) {
    radius.value = Math.round(rad);
  }
};

const setCenter = (center: google.maps.LatLng) => {
  if (value.value?.lat !== center.lat() || value.value?.long !== center?.lng()) {
    value.value = {
      lat: center?.lat(),
      long: center?.lng(),
    };
  }
};

const moveToCenter = (lat: number, long: number) => {
  mapCenter.value = {
    lat,
    lng: long,
  };
};

defineExpose({
  moveToCenter,
});
</script>
